import { COLORS } from '@cocolocala/ui-components';
import { createFontStyle, MOBILE_FONT_STYLES } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import React, { CSSProperties, FC, memo } from 'react';
import { SIGN_TYPE, SIGN_TYPES } from '~/shared/components/Sign/types';
type Props = {
  currentTabType: SIGN_TYPE;
  onClickTab: (tabType: SIGN_TYPE) => void;
  style?: CSSProperties;
};
const SignUpOrSignInTabs: FC<Props> = ({
  currentTabType,
  onClickTab,
  style
}) => {
  return <HeaderContainer style={style}>
      <Header className={currentTabType === SIGN_TYPES.SIGN_UP ? 'active' : ''} onClick={() => onClickTab(SIGN_TYPES.SIGN_UP)}>
        <HeaderTitleContainer>
          <Icon>
            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.73149 15V4.53783L2.18951 1.19385C1.73967 0.769164 1 1.08808 1 1.70672V10.39C1 10.5374 1.0615 10.6781 1.16968 10.7782L5.73149 15Z" fill="#FAEE00" stroke="#333333" strokeWidth="0.5" strokeLinejoin="round" />
              <path d="M5.73145 15V4.53783L9.27342 1.19385C9.72326 0.769164 10.4629 1.08808 10.4629 1.70672V10.39C10.4629 10.5374 10.4014 10.6781 10.2932 10.7782L5.73145 15Z" fill="#00AF9C" stroke="#333333" strokeWidth="0.5" strokeLinejoin="round" />
            </svg>
          </Icon>
          <HeaderTitle>はじめての方</HeaderTitle>
        </HeaderTitleContainer>
        <HeaderDescription>無料会員登録</HeaderDescription>
      </Header>
      <Header className={currentTabType === SIGN_TYPES.SIGN_IN ? 'active' : ''} onClick={() => onClickTab(SIGN_TYPES.SIGN_IN)}>
        <HeaderTitleContainer>
          <HeaderTitle>すでに会員の方</HeaderTitle>
        </HeaderTitleContainer>
        <HeaderDescription>ログイン</HeaderDescription>
      </Header>
    </HeaderContainer>;
};
export default memo(SignUpOrSignInTabs);
const HeaderContainer = /*#__PURE__*/styled("div")({
  name: "HeaderContainer",
  class: "h1gfabp8"
});
const Header = /*#__PURE__*/styled("div")({
  name: "Header",
  class: "h1y0uol6"
});
const HeaderTitleContainer = /*#__PURE__*/styled("div")({
  name: "HeaderTitleContainer",
  class: "h10e0br6"
});
const HeaderTitle = /*#__PURE__*/styled("div")({
  name: "HeaderTitle",
  class: "hzcjon"
});
const HeaderDescription = /*#__PURE__*/styled("div")({
  name: "HeaderDescription",
  class: "h18u1v0y"
});
const Icon = /*#__PURE__*/styled("div")({
  name: "Icon",
  class: "i1gyw23t"
});

require("./index.linaria.module.css!=!../../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");